export default __webpack_public_path__ + "static/media/logo2.c1aa51a0.png";